function EvidenceLevel() {
  return (
    <div>
      <li className="bullet-item">
        The Evidence Level (EL) is a metric developed by ClinGen that measures the strength of evidence of a
        gene-disease relationship that correlates to a qualitative classification:{' '}
        <i>"Definitive", "Strong", "Moderate", "Limited", "Conflicting Evidence"</i>, or{' '}
        <i>"No Reported Evidence" </i>(
        <a target="_blank" rel="noreferrer" href="https://www.ncbi.nlm.nih.gov/pubmed/28552198">
          Strande <i>et al.</i>, 2017{' '}
        </a>
        ). GDAs that have been reported by ClinGen will have their corresponding Evidence Level. Furthermore,
        we have adapted a similar metric reported by Genomics England PanelApp to correspond to the same
        categories from ClinGen: GDAs marked by Genomics England PanelApp as
        <i>High Evidence</i> are labeled as <i>strong</i> in DISGENET. Those labeled as{' '}
        <i>Moderate Evidence</i> are labeled as <i>moderate</i> and <i>Low Evidence</i> associations are
        labeled as <i>limited</i>. We have labeled GDAs with no evidence level as "No reported evidence"
      </li>
    </div>
  );
}

export default EvidenceLevel;
